<template>
    <ul class="tab-container" ref="tabParent">
        <li @click="changeActive(index)" class="tab" ref="tab" v-for="(tab, index) in tabList" :key="index" :class="{active: active === index}">{{tab}}</li>
        <div ref="line" class="line" :style="`width: ${lineWidth}px;`"></div>
    </ul>
</template>
<script>
export default {
    props: {
        active: {
            type: Number,
            default: 0
        },
        tabList: {
            type: Array,
            default() {
                return []
            }
        },
        tag: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            lineWidth: 0
        }
    },
    methods: {
        getComputedPosition() {
            let line = this.$refs.line;
            let tab = this.$refs.tab[this.active];
            let tabParent = this.$refs.tabParent;
            this.lineWidth = tab.offsetWidth;
            if (this.tag === 'up') {
                this.lineWidth = tab.offsetWidth - 10;
                line.style.marginLeft = tab.offsetLeft - tabParent.offsetLeft + (tab.offsetWidth - 10 - this.lineWidth) / 2 + 'px';
            } else {
                this.lineWidth = tab.offsetWidth;
                line.style.marginLeft = tab.offsetLeft - tabParent.offsetLeft + (tab.offsetWidth - this.lineWidth) / 2 + 'px';
            }
        },
        changeActive(index) {
            this.$emit('update:active', index);
            this.$nextTick(_ => {
                this.getComputedPosition();
            });
        }
    },
    mounted() {
        this.getComputedPosition();
    }
}
</script>
<style lang="less" scoped>
@active: #789AFF;
.tab-container {
    list-style: none;
    margin: 0 0 17px 0;
    color: #5C667E;
    font-size: 16px;
    padding: 0;
    user-select: none;

    .tab {
        display: inline;
        text-align: center;
        margin-right: 51px;
        cursor: pointer;
        &.active {
            color: @active;
            font-weight: 600;
        }
    }

    .line {
        height: 3px;
        width: 30px;
        border-radius: 3px;
        background: @active;
        transition: .3s ease-in-out;
        position: absolute;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SimpleTab.vue